export default __webpack_public_path__ + "static/media/slide1.5db4fee7.png";